import { ObjetKStatus } from '@siclop/kstone-vue'

export class Activity extends ObjetKStatus {
  projectId: number = 0
  projectName?: string
  lotId?: number
  lotName?: string
  functionalityId?: number
  functionalityCode?: string
  functionalityTitle?: string
  estimationScaleId?: number
  estimationScaleCode?: string
  estimationScaleLabel?: string
  activityTypeId?: number
  activityTypeCode?: string
  activityTypeLabel?: string
  description: string = ''
  date: Date = new Date()
  hours: number = 0
  totalCost: number = 0
  employeeId: number = 0
  employeeName?: string
  gitLabIssueId?: number
  gitLabMergeRequestId?: number
  isBillable: boolean = true
  isInvoiced: boolean = false
  invoiceId?: number
  notes: string = ''

  constructor(data?: Partial<Activity>) {
    super(data)
    if (data) {
      this.projectId = data.projectId ?? 0
      this.projectName = data.projectName
      this.lotId = data.lotId
      this.lotName = data.lotName
      this.functionalityId = data.functionalityId
      this.functionalityCode = data.functionalityCode
      this.functionalityTitle = data.functionalityTitle
      this.estimationScaleId = data.estimationScaleId
      this.estimationScaleCode = data.estimationScaleCode
      this.estimationScaleLabel = data.estimationScaleLabel
      this.activityTypeId = data.activityTypeId
      this.activityTypeCode = data.activityTypeCode
      this.activityTypeLabel = data.activityTypeLabel
      this.description = data.description ?? ''
      this.date = data.date ? new Date(data.date) : new Date()
      this.hours = data.hours ?? 0
      this.totalCost = data.totalCost ?? 0
      this.employeeId = data.employeeId ?? 0
      this.employeeName = data.employeeName
      this.gitLabIssueId = data.gitLabIssueId
      this.gitLabMergeRequestId = data.gitLabMergeRequestId
      this.isBillable = data.isBillable ?? true
      this.isInvoiced = data.isInvoiced ?? false
      this.invoiceId = data.invoiceId
      this.notes = data.notes ?? ''
    }
  }
}
